import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Candidates from "@/pages/Candidates";
import Companies from "@/pages/Companies";
import ContactForm from "@/pages/ContactForm";
import ContactUs from "@/pages/ContactUs";
import LegalNotice from "@/pages/LegalNotice";

function App() {
  return (
    <div className="App font-sans">
      <BrowserRouter>
        <Header />
        <main className="pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/candidats" element={<Candidates />} />
            <Route path="/entreprises" element={<Companies />} />
            <Route path="/formulaire" element={<ContactForm />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/mentions-legales" element={<LegalNotice />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
